import React, { Component, createRef  } from 'react';
import { Sidebar, Header } from '..';
import Moment from 'react-moment';
import { Button, Row, Col, Image } from 'react-bootstrap'
import EndpointConstant from './../../constants/EndpointConstant';
import utils from './../../utils';
import Pagination from '../Pagination/Pagination';
import RoleConstant from '../../constants/RoleConstant';
import ScorecardQuestionariesSearch from './ScorecardQuestionariesSearch';
import EditScorecardQuestionaries from './EditScorecardQuestionaries';
import ConfirmationModal from '../PopupModels/ConfirmationModal';
import MessageConstant from './../../constants/MessageConstant';
import PopupModels from '../PopupModels/PopupModels'
import './ScorecardQuestionaries.css';
//import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

class ScorecardQuestionaries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionariesDetails: [],
      showpagination: false,
      currentTodos: [],
      addEditShow: false,
      selectedQuestionSet: {},
      isViewMode: false,
      showDeleteConfirmation: false,
      qid: '',
      questionariesSuccessModel: false,
      defaultQuestionaries: [],
      deleteMessage: '',
      deletefail: false,
      isQuestionNew: false,
      isEditable: false,
      columnWidth: 450,
      displayTexts: {},
      sortedField : '',
      sortingOrder : 'sortOne',
      sortingData : [],
      // isNew: false, 
      // isCopy: false
    }
    this.columnRefs = {};
    this.headerRef = createRef();
    this.onChangePage = this.onChangePage.bind(this);
    this.hideViewDetails = this.hideViewDetails.bind(this);
    this.searchResult = this.searchResult.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.onSortInteraction = this.onSortInteraction.bind(this);
    this.calculateCharLimit = this.calculateCharLimit.bind(this);
  }
    
  sortInteration(prop, sortId) {
    return (x, y) => {      
      x[prop] === undefined ? x[prop] = "" :'';
      y[prop] === undefined ? y[prop] = "" :'';

      let a = JSON.parse(JSON.stringify(x))
      let b = JSON.parse(JSON.stringify(y))
  
      if (sortId.sortId === 'sort') {
        return a[prop].toString().localeCompare(b[prop].toString());
      }
      else if (sortId.sortId === 'sort-up') {
        return b[prop].toString().localeCompare(a[prop].toString());
      }
      else if (sortId.sortId === 'sort-down') {
        return a;
      } 
    }
  }

  componentDidMount() {
    this.getQuestionariesList();
    window.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.handleMouseUp);
  }

  getQuestionariesList() {
    let data = {};
    let self = this;
    utils.makeRequest(this, EndpointConstant.SCORECARD_QUESTIONARIE_LIST, data, function (result) {
      utils.hideLoader();
      if (result.error === false) {
        self.loading = false;
        const questions = result.Questionaries;
        self.setState({
          questionariesDetails: questions,
          defaultQuestionaries: questions,
        }, () => self.setState({ showpagination: !!result.Questionaries.length }));
      }
    })
  }

  onChangePage(currentTodos) {
    this.setState({ currentTodos: currentTodos }, () => { this.setState({ showpagination: true }) })
  }

  add3Dots(string, limit) {
    var dots = "...";
    if (string && string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  }

  getSortingData(field, order) {
    let newSortingData;
    if (order!== "") {
      newSortingData = [...this.state.sortingData, { sortedField: field, sortingOrder: order }];
    } else {
      newSortingData = [...this.state.sortingData];
    }    
    return newSortingData    
  }

  onSortInteraction(data, e) {
    e.preventDefault();    
    let className = e.target.className;    
    let sortId = e.target.id;
    let handleSortingOrder = "";

    if (sortId === 'sort') {
      e.target.id = 'sort-up';
      e.target.className = 'fas fa-sort-up';
      handleSortingOrder = 'sort-up';
    }
    else if (sortId === 'sort-up') {
      e.target.id = 'sort-down';
      e.target.className = 'fas fa-sort-down';
      handleSortingOrder = 'sort-down';
    }
    else if (sortId === 'sort-down') {
      e.target.id = 'sort';
      e.target.className = 'fas fa-sort';
      handleSortingOrder = 'sort';
    }
    const { questionariesDetails } = this.state;
    switch (data) {
      case "questionset":
        let questionSetSorting = this.getSortingData(
          "Questionset",
          handleSortingOrder
        );
        this.setState({
          questionariesDetails: [...questionariesDetails].sort(
            this.sortInteration("questionsetName", { sortId: sortId })
          ),
          sortingData: questionSetSorting,
        });
        break;
      case "createdDate":
        let createdDateSorting = this.getSortingData(
          "CreatedDate",
          handleSortingOrder
        );
        this.setState({
          questionariesDetails: [...questionariesDetails].sort(
            this.sortInteration("createdAt", { sortId: sortId })
          ),
          sortingData: createdDateSorting,
        });
        break;
      case "createdBy":
        let createdBySorting = this.getSortingData(
          "CreatedBy",
          handleSortingOrder
        );
        this.setState({
          questionariesDetails: [...questionariesDetails].sort(
            this.sortInteration("createdByName", { sortId: sortId })
          ),
          sortingData: createdBySorting,
        });
        break;
      default:
        break;
    }
  }

  handleMouseDown(event, index) {
    if (event.target.classList.contains('resizable')) {
      this.resizingIndex = index;
      window.addEventListener('mousemove', this.handleMouseMove);
    }
  }
  handleMouseMove(event) {
    if (this.resizingIndex !== null) {
      const minWidth = 100; // Set your minimum width here
      const newWidth = Math.max(minWidth, event.clientX - this.columnRefs[0]?.getBoundingClientRect().left || this.headerRef[0]?.getBoundingClientRect().left);
      const charLimit = this.calculateCharLimit(newWidth);
      const displayTexts = { ...this.state.displayTexts };
      displayTexts[this.resizingIndex] = this.add3Dots(this.state.questionariesDetails[this.resizingIndex]?.questionsetName, charLimit);
      this.setState({ columnWidth: newWidth, displayTexts });
      if (this.headerRef.current) {
        this.headerRef.current.style.width = `${newWidth}px`;
      }
    }
  }

  handleMouseUp() {
    this.resizingIndex = null;
    window.removeEventListener('mousemove', this.handleMouseMove);
  }

  calculateCharLimit(width) {
    // Assuming an average character width of 8 pixels
    return Math.floor(width / 8);
  }

  getCurrentDisplayedQuestionnaires() {
    return this.state.currentTodos && this.state.currentTodos.length > 0
      ? this.state.currentTodos
      : this.state.questionariesDetails;
  }

  getSheetData(questionnaire) {
    if (Array.isArray(questionnaire.questionaries) && questionnaire.questionaries.length) {
      const createdAt = questionnaire.createdAt
        ? new Date(questionnaire.createdAt).toLocaleDateString()
        : '';

      const totalWeightage = 100;

      const rows = [
        ['Questionset Name:', questionnaire.questionsetName || ''],
        ['Created Date:', createdAt],
        ['Created By:', questionnaire.createdByName || ''],
        [],
        ['Question', 'Question Type', 'Response Options', 'Criticality', 'Weightage', 'Case section']
      ];
    
      questionnaire.questionaries.forEach((q) => {
        const options = normalizeQuestionOptionsForExport(q);

        rows.push([
          q.question || '',
          q.type || '',
          options,
          q.weightage || '',
          q.numericWeightage || '',
          q.questionSectionType || ''
        ]);
      });
      
      rows.push([]);

      rows.push(['Passing Score:', questionnaire.thresholdValue ?? questionnaire.passingScore ?? '']);
      rows.push(['Total Weightage:', Number.isFinite(totalWeightage) ? totalWeightage : '']);
      return rows;
    }
    
    const rows = [];
    const addRow = (label, value) => {
      rows.push([label, value == null ? '' : value]);
    };

    const addObjectRows = (obj, parentLabel) => {
      Object.keys(obj).forEach((key) => {
        const value = obj[key];
        const label = parentLabel ? `${parentLabel}.${key}` : key;

        if (Array.isArray(value)) {
          addRow(label, '');
          value.forEach((item, idx) => {
            if (item && typeof item === 'object') {
              addObjectRows(item, `${label}[${idx}]`);
            } else {
              addRow(`${label}[${idx}]`, item);
            }
          });
        } else if (value && typeof value === 'object') {
          addObjectRows(value, label);
        } else {
          addRow(label, value);
        }
      });
    };

    addObjectRows(questionnaire, '');
    return rows;
  }
  
  getSheetName(questionnaire, index) {
    const rawName = questionnaire.questionsetName || `Questionnaire ${index + 1}`;
    const cleaned = rawName.toString().replace(/[:\\/?*\[\]]/g, '').trim();

    const suffix = `_${index + 1}`;
    const maxLength = 31;
    const truncated = cleaned.substring(0, Math.max(0, maxLength - suffix.length)).trim();

    return truncated.length > 0 ? `${truncated}${suffix}` : `Sheet${index + 1}`;
  }

  exportQuestionnaires = async () => {
    const questionnaires = this.getCurrentDisplayedQuestionnaires();
    if (!questionnaires || questionnaires.length === 0) return;

    const workbook = new ExcelJS.Workbook();

    questionnaires.forEach((questionnaire, index) => {
      const sheetData = this.getSheetData(questionnaire);
      const sheetName = this.getSheetName(questionnaire, index);
      const worksheet = workbook.addWorksheet(sheetName);

      worksheet.addRows(sheetData);

      // layout: header row is row 5, questions follow
      const headerRowIndex = 5;
      const qCount = Array.isArray(questionnaire.questionaries) ? questionnaire.questionaries.length : 0;
      const bodyStart = headerRowIndex + 1;
      const bodyEnd = headerRowIndex + qCount; // inclusive

      const thinBorder = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      };

      // Header row styling + border (row 5)
      const headerRow = worksheet.getRow(headerRowIndex);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = thinBorder;
      });

      // Add borders only for the question data area (A..F, rows bodyStart..bodyEnd)
      const cols = ['A', 'B', 'C', 'D', 'E', 'F'];
      for (let r = bodyStart; r <= bodyEnd; r++) {
        cols.forEach((col) => {
          const cell = worksheet.getCell(`${col}${r}`);
          cell.border = thinBorder;
          cell.alignment = { vertical: 'top', wrapText: true };
        });
      }

      // Metadata labels (A1..A3) bold but NO borders
      ['A1', 'A2', 'A3'].forEach((addr) => {
        const labelCell = worksheet.getCell(addr);
        if (labelCell && labelCell.value) labelCell.font = { bold: true };
      });

      // Make only the Passing Score and Total Weightage LABELS bold (column A). NO borders on these.
      worksheet.eachRow((row) => {
        const label = row.getCell(1).value;
        if (
          label === 'Passing Score' ||
          label === 'Total Weightage' ||
          label === 'Passing Score:' ||
          label === 'Total Weightage:'
        ) {
          row.getCell(1).font = { bold: true };
          // keep value cell normal and without border
        }
      });

      // set column widths
      worksheet.columns = [
        { key: 'A', width: 32 },
        { key: 'B', width: 20 },
        { key: 'C', width: 15 },
        { key: 'D', width: 18 },
        { key: 'E', width: 22 },
        { key: 'F', width: 40 }
      ];
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `ScorecardQuestionnaires_${new Date().toISOString().slice(0, 10)}.xlsx`;
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
  }

  viewQuestionarieDetails(questionDetails) {
    this.setState({ addEditShow: true, selectedQuestionSet: questionDetails, isViewMode: true, isQuestionNew: true, isEditable: true })
  }

  editQuestionaries(questionDetails) {
    this.setState({ addEditShow: true, selectedQuestionSet: questionDetails, isViewMode: false, isQuestionNew: true, isEditable: true })
  }

  // copyQuestionaries(questionDetails) {
  //   this.setState({ addEditShow: true, selectedQuestionSet: questionDetails, isViewMode: false, isQuestionNew: false, isEditable: false, isNew: true, isCopy: true })
  // }


  deleteQuestionaries(questionSet) {
    this.setState({ qid: questionSet.id, showDeleteConfirmation: true })
  }

  handleDeleteQuestion(qid) {
    let data = { id: qid };
    let self = this;
    utils.makeRequest(this, EndpointConstant.DELETE_SCORECARD_QUESTIONARIE, data, function (result) {
      if (result.error === false) {
        self.loading = false;
        const questions = result.Questionaries;
        self.setState({
          questionariesDetails: questions,
          defaultQuestionaries: questions,
          showDeleteConfirmation: false,
          questionariesSuccessModel: true

        }, () => self.setState({ showpagination: !!result.Questionaries.length }));
      }
      else {
        self.loading = false;
        if (result && result.errorCode === "Q_IN_SCORECARD") {
          self.setState({ deleteMessage: MessageConstant.QUESTIONSET_SCORCARDS, showDeleteConfirmation: false, deletefail: true  })
        }
      }
      // self.setState({ showDeleteConfirmation: false, })
  })
}

  hideViewDetails() {
    this.setState({ addEditShow: false })
  }

  hideDeletePopup() {
    this.setState({ qid: '', showDeleteConfirmation: false })
  }

  handlePopupClose() {
    this.setState({ questionariesSuccessModel: false, deletefail: false })
    // window.location.reload(false)
  }

  searchResult(result) {
    this.setState({ questionariesDetails: result })
  }

  render() {
    // {console.log(this.headerRef)}
    const QuestionarieList = this.state.currentTodos.map((data, index) => {
      const charLimit = this.calculateCharLimit(this.state.columnWidth);
      const displayText = this.state.displayTexts[index] || this.add3Dots(data.questionsetName, charLimit);
      return (        
        <tr key={index}>
         <td
            ref={(el) => (this.columnRefs[index] = el)}
            title={data.questionsetName}
            className="resizable1"
            style={{ width: this.state.columnWidth }}
            onMouseDown={(e) => this.handleMouseDown(e, index)}
          >
            {displayText}
          </td>
          <td>
            <Moment format="MM/D/YYYY">{data.createdAt}</Moment></td>
          <td>{data.createdByName}</td>
          <td>
            <Row>
              <Col  xs lg="4" className='pr-0 pl-2'>             
                <span onClick={() => this.editQuestionaries(data)} className='view-details'>
                  <i className="fa fa-eye"></i>&nbsp;View Details</span>
              </Col>
              <Col  xs lg="4" className='pr-0 pl-2' ><span onClick={() => this.deleteQuestionaries(data)} className='delete-style'>
                <Image src="/Images/ico-delete.png" className='image-padding'></Image>Delete</span>
              </Col> 
            </Row>
          </td>
          {/* <td>
            <Row>
               
            </Row>
          </td> */}
        </tr>
      );
    });
    return (      
      <div>
        <Header />
        <div className="sidebar">
          <Sidebar />
        </div>
        {this.state.addEditShow ? <EditScorecardQuestionaries hideViewDetails={this.hideViewDetails} questionDetails={this.state.selectedQuestionSet} questionSetEditMode={!this.state.isViewMode} scorecardQuestionDetails={this.state.questionariesDetails} isQuestionNew={!this.state.isQuestionNew} isEditable={this.state.isEditable}/> :
          <div className="menu-content">
            <div>
              <ScorecardQuestionariesSearch questionDetails={this.state.defaultQuestionaries} searchResult={this.searchResult} />
              <div>
                <table>
                  <thead>
                    <tr>
                      <th className="resizable" onMouseDown={(e) => this.handleMouseDown(e, 'header')} onClick={(e) => this.onSortInteraction('questionset', e)}>Questionset<i className="fas fa-sort" id="sort"></i></th>
                      {/* <th>Questionset</th> */}
                      <th onClick={(e) => this.onSortInteraction('createdDate', e)}>Created Date<i className="fas fa-sort" id="sort"></i></th>
                      <th onClick={(e) => this.onSortInteraction('createdBy', e)}>Created By<i className="fas fa-sort" id="sort"></i></th>
                      <th>Action</th>                      
                    </tr>
                  </thead>
                  <tbody>
                    {QuestionarieList}
                  </tbody>
                </table>               
                <Row className='padding-top'>
                  <Col>
                    { // eslint-disable-next-line react/no-string-refs
                      this.state.showpagination ? <Pagination ref="pagination" data={this.state.questionariesDetails} onChangePage={this.onChangePage} /> : ''}
                  </Col>

                  <Col className='right-align padding-top'>
                    <Button className='button-color download-font-size add-scorecard' onClick={this.exportQuestionnaires}>Download</Button>
                    <Button className='button-color download-font-size add-scorecard' onClick={() => this.editQuestionaries({})}>Add Question set</Button>
                    {/* <Button className='button-color download-font-size' onClick={this.downloadScorecard}>Download Question set</Button> */}
                  </Col>
                </Row>
              </div>
            </div>
            <PopupModels showPopup={this.state.questionariesSuccessModel} iconFlag="success" message={MessageConstant.DELETE_QUESTIONSET} handleClosePopup={this.handlePopupClose.bind(this)} />
            <PopupModels showPopup={this.state.deletefail} iconFlag="error" message={this.state.deleteMessage} handleClosePopup={this.handlePopupClose.bind(this)} />
            <ConfirmationModal showModal={this.state.showDeleteConfirmation}
              handleCloseModal={this.hideDeletePopup.bind(this)}
              message={MessageConstant.QUESTIONSET_DELETE_CONFIRMATION}
              navigate={() => { this.handleDeleteQuestion(this.state.qid, this.state.questionDetail) }} />
          </div>}
      </div>
    )
  } 
}

export default ScorecardQuestionaries

export const normalizeQuestionOptionsForExport = (question) => {
  if (!question || typeof question !== 'object') return '';

  if (question.type === 'Y/N') {
    const directValue = question.options;

    if (Array.isArray(directValue)) {
      const selected = directValue.find(
        (value) => value !== undefined && value !== null && value !== ''
      );
      return selected !== undefined ? String(selected) : 'Yes';
    }

    if (directValue && typeof directValue === 'object') {
      const selected = Object.values(directValue).find(
        (value) => value !== undefined && value !== null && value !== ''
      );
      return selected !== undefined ? String(selected) : 'Yes';
    }

    if (typeof directValue === 'string' && directValue.trim() !== '') {
      return directValue;
    }

    return 'Yes';
  }

  if (Array.isArray(question.options)) {
    return question.options
      .filter((value) => value !== undefined && value !== null && value !== '')
      .join(', ');
  }

  if (question.options && typeof question.options === 'object') {
    return Object.entries(question.options)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
  }

  if (typeof question.options === 'string') {
    return question.options;
  }

  return '';
};